import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { HotelStayTagType } from './StayTag.model';
import type { HotelStayTag, StayTagData } from './StayTag.model';

const { t } = i18n.global;

export function getStayTagData(stayTag: HotelStayTag): StayTagData {
  switch (stayTag.type) {
    case HotelStayTagType.FreeCancellation:
      return {
        title: `${t('filter.rules.free_cancellation')}`,
        text: ` ${t('planner.until').toLowerCase()} ${stayTag.until}`,
        type: 'positive',
      };
    case HotelStayTagType.SpecialPrice:
      return {
        title: `${t('planner.special_price')} -`,
        text: ` ${t('planner.non_refundable').toLowerCase()}`,
        type: 'grey',
      };
    default:
      throw new Error('It should not try to print a label');
  }
}
